import { workflowSteps } from '../../data/content';
import './Workflow.css';

function Workflow() {
  return (
    <section id="como-trabalhamos" className="section workflow">
      <div className="container">
        <div className="section-header">
          <h2>Como trabalhamos</h2>
          <p>Do diagnóstico à evolução contínua — com transparência em cada etapa.</p>
        </div>

        <div className="workflow-grid">
          {workflowSteps.map((step, index) => (
            <div key={step.title} className="workflow-step">
              <div className="workflow-illustration">{step.icon}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
              {index < workflowSteps.length - 1 && (
                <span className="workflow-arrow">↓</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Workflow;
